import type { WelcomeStep } from "../types/WelcomeFlowTypes";

// The large centered intro shown before the anchored steps begin. The anchored steps themselves
// are loaded live from the Project Overview flow guide (see loadProjectOverviewGuideSteps.ts), not
// listed here. No exit before the last anchored step, which finishes the tour and opens the
// start-project dialog instead of navigating.
export const newUserSteps: WelcomeStep[] = [{ key: "welcome", label: "Welcome", centered: true }];
